export const DEFAULT_USER_LANGUAGE = 'en-US';
export const I18_LOCAL_STORAGE_KEY = 'ops-selected-lang';

enum LANGUAGES {
  ENGLISH = 'English',
  SPANISH = 'Español',
  HINDI = 'हिन्दी',
  TELUGU = 'తెలుగు',
  PORTUGESE = 'Português',
}

enum LANGUAGES_CODE {
  ENGLISH = 'en',
  SPANISH = 'es',
  HINDI = 'hin',
  TELUGU = 'te',
  PORTUGESE = 'pt',
}

enum COUNTRY_CODE {
  US = 'US',
  UK = 'UK',
  INDIA = 'IN',
  SPAIN = 'ES',
  BRAZIL = 'BR',
}

export type I18NLanguage = {
  label: LANGUAGES;
  countryCode: COUNTRY_CODE;
  langCode: LANGUAGES_CODE;
  code: string;
  isActive: boolean;
};

export const i18NSupportedLanguages: I18NLanguage[] = [
  {
    label: LANGUAGES.ENGLISH,
    countryCode: COUNTRY_CODE.US,
    langCode: LANGUAGES_CODE.ENGLISH,
    code: `${LANGUAGES_CODE.ENGLISH}-${COUNTRY_CODE.US}`,
    isActive: true,
  },
  {
    label: LANGUAGES.ENGLISH,
    countryCode: COUNTRY_CODE.UK,
    langCode: LANGUAGES_CODE.ENGLISH,
    code: `${LANGUAGES_CODE.ENGLISH}-${COUNTRY_CODE.UK}`,
    isActive: true,
  },
  {
    label: LANGUAGES.PORTUGESE,
    countryCode: COUNTRY_CODE.BRAZIL,
    langCode: LANGUAGES_CODE.PORTUGESE,
    code: `${LANGUAGES_CODE.PORTUGESE}-${COUNTRY_CODE.BRAZIL}`,
    isActive: true,
  },
  {
    label: LANGUAGES.HINDI,
    countryCode: COUNTRY_CODE.INDIA,
    langCode: LANGUAGES_CODE.HINDI,
    code: `${LANGUAGES_CODE.HINDI}-${COUNTRY_CODE.INDIA}`,
    isActive: false,
  },
  {
    label: LANGUAGES.TELUGU,
    countryCode: COUNTRY_CODE.INDIA,
    langCode: LANGUAGES_CODE.TELUGU,
    code: `${LANGUAGES_CODE.TELUGU}-${COUNTRY_CODE.INDIA}`,
    isActive: false,
  },
  {
    label: LANGUAGES.SPANISH,
    countryCode: COUNTRY_CODE.SPAIN,
    langCode: LANGUAGES_CODE.SPANISH,
    code: LANGUAGES_CODE.SPANISH,
    isActive: false,
  },
];

export enum SUPPORTED_MODULES {
  GENERIC = 'generic',
  TESTING = 'testing',
  DASHBOARD = 'dashboard',
  USERPERMISSION = 'userpermission',
  MODELDETAILS = 'modeldetails',
  MONITORING = 'monitoring',
  ACTIVITYLOG = 'activitylog',
}
